import { render, staticRenderFns } from "./vettingTable.vue?vue&type=template&id=f3d32cd0&"
import script from "./vettingTable.vue?vue&type=script&lang=js&"
export * from "./vettingTable.vue?vue&type=script&lang=js&"
import style0 from "./vettingTable.vue?vue&type=style&index=0&id=f3d32cd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports